// /theory/db 같은 카테고리 페이지 dock 높이가 모바일 하단 도구의 기준이다.
// 카테고리 dock의 기존 구조(56px grid + 상하 6px padding)를 기준으로 맞춘다.
// 새 하단 dock도 이 값을 공유해 페이지마다 높이가 달라지지 않게 유지한다.
export const MOBILE_BOTTOM_TOOL_DOCK_HEIGHT_PX = 68;
export const MOBILE_BOTTOM_TOOL_DOCK_HEIGHT = `${MOBILE_BOTTOM_TOOL_DOCK_HEIGHT_PX}px`;
